import React from 'react';

import * as S from './style';

interface ButtonProps {
  label: string;
  asLink: boolean;
  path: string;
  className: string;
  iconClassName: string;
  icon: JSX.Element;
  onClick: () => void;
}

const Button: React.FC<Partial<ButtonProps>> = ({ 
  children,
  asLink,
  path, 
  className,
  onClick,
  icon,
  iconClassName,
  label,
}) => {
  if (asLink) {
    return (
      <S.ButtonAsLink 
        className={className} 
        to={`${path}`} 
        role="button"
      >
        {children}
      </S.ButtonAsLink>
    )
  }

  return (
    <button 
      onClick={onClick} 
      className={className}
    >
      {icon && ( 
        <i className={iconClassName}>{icon}</i> 
      )}
      {label}
    </button>
  )
}

export default Button;
  
